import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22PageWrapper.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../styles/fonts/FixelDisplay-Regular.woff2%22,%22weight%22:%22400%22},{%22path%22:%22../../styles/fonts/FixelDisplay-SemiBold.woff2%22,%22weight%22:%22600%22},{%22path%22:%22../../styles/fonts/FixelDisplay-Bold.woff2%22,%22weight%22:%22700%22}],%22variable%22:%22--font-fixel%22,%22display%22:%22swap%22}],%22variableName%22:%22fixelDisplayFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'fixelDisplayFont', 'fixelDisplayFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
